export interface ProductRequest {
  data: {
    id: string;
    Name?: string;
    status: ProductRequestStatusEnum;
    contractSigned: null | boolean | "True" | "False";
    totalAmount: null | number;
    Created_Time: string;
    deals: Deal[];
    productRequestType: null | ToolEnum;
    resultFile: null | ResultFile[];
    requestDetails: Record<string, string>;
    leftToPay: null | number;
    paid: number;
    link?: string;
  }[];
  total: number;
  page: number;
  totalPages: number;
  statusCount?: StatusCount;
}

export interface StatusCount {
  Done: number;
  Pending: number;
  ["Waiting for actions"]: number;
  ["In Progress"]: number;
}

export enum ProductRequestStatusEnum {
  PENDING = "Pending",
  WAITING_FOR_ACTIONS = "Waiting for actions",
  IN_PROGRESS = "In Progress",
  REJECTED = "Rejected",
  DONE = "Done",
}

export interface ResultFile {
  File_Name__s: string;
  Size__s: number;
  id: string;
  File_Id__s: string;
}

export interface Deal {
  id: string;
  Created_Time: string;
  Amount: number;
  chargedAmount: number;
  invoice: string;
  Contact_Role: null;
  productRequest?: {
    name: ToolEnum;
    id: string;
  };
}

export enum ToolEnum {
  TRACK_MASTER = "TRACK_MASTER",
  BANK_DISPUTE = "BANK_DISPUTE",
  EXCHANGE_DISPUTE = "EXCHANGE_DISPUTE",
  WEB_INTELLIGENCE = "WEB_INTELLIGENCE",
  BLOCKCHAIN_ANALYSIS = "BLOCKCHAIN_ANALYSIS",
}
